import { createStyles, makeStyles } from "@material-ui/core";
import {
    baseColors,
    Layout,
    LayoutCell,
    RelodeTheme,
    ResearchIcon,
    Text,
    useGridStyles,
} from "../../../src";
import cls from "classnames";
import * as React from "react";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            normalizedPanel: {
                backgroundColor: baseColors.cool_gray,
                border: `solid 1px ${baseColors.warm_gray}`,
                borderRadius: 4,
                padding: theme.spacing(2),
            },
            normalizedPanelHeader: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            },
            normalizedPanelTitle: {
                color: theme.relode.colors.pagePrimaryColor,
            },
            normalizedPanelDescription: {
                color: theme.relode.colors.backgroundText.light,
            },
        }),
    {
        name: "NormalizedPanel",
    }
);

interface NormalizedPanelProps {
    children: React.ReactNode;
}

export const NormalizedPanel = (props: NormalizedPanelProps) => {
    const { children } = props;
    const classes = useStyles(props);
    const gridClasses = useGridStyles(props);

    return (
        <LayoutCell columns={2} className={classes.normalizedPanel}>
            <div className={gridClasses.entireRow}>
                <div className={classes.normalizedPanelHeader}>
                    <ResearchIcon />
                    <Text
                        variant="subtitle2"
                        display="inline"
                        className={classes.normalizedPanelTitle}
                    >
                        insights - market research
                    </Text>
                </div>
            </div>
            <Text
                paragraph
                variant="body2"
                className={cls(
                    gridClasses.entireRow,
                    classes.normalizedPanelDescription
                )}
            >
                Provide the best matched job title and location for accurate
                market data.
            </Text>
            <Layout mode="50/50">{children}</Layout>
        </LayoutCell>
    );
};
